export class IllumioGeoLocation {
    isEnabled = true;
    isDebug = true;
    currentPosition = null;

    constructor() {
        if (this.isEnabled && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.getCurrentPositionHandler.bind(this));
        }
    }

    getCurrentPositionHandler(position) {
        console.debug('Curent Position: ' + position);  
        console.debug(position);
        this.currentPosition = position;
    }
}
